/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'
import { useState } from 'react'
import { OnChangeEventContext } from 'react-crane'

import { ConfirmModal } from '../../../shared/modal'
import { Select } from '../../../shared/input'
import { PlanOption } from '../../../../types'

const autoContainerCss = css`
  position: relative;
  padding-top: 20px;
  margin-left: -8px;
`

type ConfirmReplacePrimaryModalProps = {
  /** The text for the modal body */
  bodyText?: string
  /** The text of the confirm button */
  confirmText?: string
  /** Determines visibility of modal */
  isOpen: boolean
  /** Event callback when Confirm Button is triggered */
  onConfirm: (id: string) => void
  /** The list of the user's plans to be displayed in the dropdown */
  planOptions: PlanOption[]
  /** The title of the modal */
  title?: string
}

const defaultProps: Pick<ConfirmReplacePrimaryModalProps, 'bodyText' | 'confirmText' | 'title'> = {
  bodyText: 'Choose another plan as your primary plan:',
  confirmText: 'Ok',
  title: 'Remove as Primary Plan'
}

export const ConfirmReplacePrimaryModal = ({
  bodyText,
  confirmText,
  isOpen,
  onConfirm,
  planOptions,
  title
}: ConfirmReplacePrimaryModalProps) => {
  const [inputValue, setInputValue] = useState<PlanOption | undefined>(undefined)

  const onChangeEvent = (e: OnChangeEventContext) => {
    setInputValue(e.value as PlanOption)
  }

  const onConfirmModal = () => {
    if (inputValue && inputValue.id) {
      onConfirm(inputValue.id)
    }
  }

  return (
    <ConfirmModal
      confirmText={confirmText}
      confirmButtonDisabled={!inputValue || inputValue.id.length === 0}
      isOpen={isOpen}
      onConfirm={onConfirmModal}
      title={title!}
    >
      {bodyText}
      <div css={autoContainerCss}>
        <Select
          id="plan"
          label="Select a new Plan"
          labelKey="label"
          name="plan"
          onChange={onChangeEvent}
          options={planOptions}
          value={inputValue && inputValue}
          valueKey="id"
        />
      </div>
    </ConfirmModal>
  )
}

ConfirmReplacePrimaryModal.defaultProps = defaultProps

export default ConfirmReplacePrimaryModal
